import React from "react";

// The organizations Cloud Print works with, in a band under the home page's hero.
// A new one is a logo in public/assets/img/partners/ and a line here; width and
// height are the file's own, to keep its shape before it loads.
const PARTNERS = [
  { name: "CU", logo: "/assets/img/partners/cu.svg", width: 340, height: 212 },
  { name: "Canon", logo: "/assets/img/partners/canon.svg", width: 800, height: 360 },
];

const Partners = () => (
  <section className="home-partners" aria-labelledby="home-partners-title">
    <div className="container home-partners-inner">
      <h2 id="home-partners-title" className="home-partners-title">
        Хамтрагч байгууллага
      </h2>
      <ul className="home-partners-list">
        {PARTNERS.map((partner) => (
          <li key={partner.name}>
            <img
              src={partner.logo}
              width={partner.width}
              height={partner.height}
              loading="lazy"
              alt={partner.name}
            />
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Partners;
